import { APIClient } from '@/services'
import { ProfilePrompt } from '@/types'
import { createQueryManager, PaginationResponse } from '@codeleap/query'
import { queryClient } from '../queryClient'
import { api } from '@/app'
import { getListQueryParams } from '@/utils'

type FilterParams = {
  including_keys: Array<keyof APIClient.Session.Profile>
}

export const profileQuestionsManager = createQueryManager<ProfilePrompt, FilterParams>({
  name: 'community-profile-question',
  queryClient: queryClient.client,

  async listFn(limit, offset, filters) {
    const response = await api.get<PaginationResponse<ProfilePrompt>>('community/profile-prompts/', {
      params: {
        including_keys: getListQueryParams(filters?.including_keys),
      },
    })

    return response.data?.results
  },
})
